<template>
  <not-found />
</template>
<script>
import NotFound from '@/components/error/NotFound'
export default {
  components: {
    NotFound,
  },
}
</script>
